module.exports = __webpack_public_path__ + "static/media/tape-in.ac83638e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Sounds/tape-in.mp3
// module id = 39
// module chunks = 1